@if (customer()) {
    <telxl-shared-customer-activity-history-panel
        [customer]="customerId()"
        [height]="height()"
    />
} @else if (agent()) {
    <telxl-shared-agent-activity-history-panel
        [agent]="agentId()"
        [height]="height()"
    />
}
